import React from 'react';
import Header from './Common/header';
import './css/index';

export default class Content_video extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@td9xza`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_${eid}`}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div id="video_play_576" style={{ width: '100%' }}>
                                    <video src="/page/resource/userfile/image/elementPrew/wxdzfp.mp4"
                                      autoPlay="autoplay"
                                      controlsList="nodownload"
                                      controls
                                      style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_video.js